const reduce = require('./algs/reducePromise/index');
const map = require('./algs/mapPromise/index');
module.exports = {
  reduce,
  map
};